import { setProperty } from './tools/fn';
import { A3, A4, A5, A6, LARGE_MARGINS, LEGAL, LETTER, NORMAL_MARGINS, NO_MARGINS, TABLOID, } from './page';
export const landscape = setProperty('landscape')(true);
export const portrait = setProperty('landscape')();
export const paperSize = (paper) => Array.isArray(paper)
    ? setProperty('paperWidth', 'paperHeight')(...paper)
    : setProperty('paperWidth', 'paperHeight')(paper.width, paper.height);
export const a3 = paperSize(A3);
export const a4 = paperSize(A4);
export const a5 = paperSize(A5);
export const a6 = paperSize(A6);
export const legal = paperSize(LEGAL);
export const letter = paperSize(LETTER);
export const tabloid = paperSize(TABLOID);
export const marginSizes = (margins) => Array.isArray(margins)
    ? setProperty('marginTop', 'marginRight', 'marginBottom', 'marginLeft')(...margins)
    : setProperty('marginTop', 'marginRight', 'marginBottom', 'marginLeft')(margins.top, margins.right, margins.bottom, margins.left);
export const noMargins = marginSizes(NO_MARGINS);
export const normalMargins = marginSizes(NORMAL_MARGINS);
export const largeMargins = marginSizes(LARGE_MARGINS);
